import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";
import { useLang } from "../context/LangContext";
import { WHATSAPP_NUMBER, INSTAGRAM } from "../lib/api";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-ink text-canvas mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-heading text-3xl mb-3 text-canvas">Pasionaria</h3>
          <p className="text-canvas/60 text-sm max-w-xs leading-relaxed">{t("footer_tagline")}</p>
        </div>
        <div className="flex flex-col gap-2">
          <span className="overline text-brand-secondary mb-2">{t("nav_shop")}</span>
          <Link to="/tienda" className="text-canvas/70 hover:text-canvas text-sm transition-colors">{t("nav_shop")}</Link>
          <Link to="/nosotras" className="text-canvas/70 hover:text-canvas text-sm transition-colors">{t("nav_about")}</Link>
          <Link to="/contacto" className="text-canvas/70 hover:text-canvas text-sm transition-colors">{t("nav_contact")}</Link>
        </div>
        <div className="flex flex-col gap-3">
          <span className="overline text-brand-secondary mb-2">{t("nav_contact")}</span>
          <a
            href={INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="flex items-center gap-2 text-canvas/70 hover:text-canvas text-sm transition-colors"
          >
            <Instagram size={18} strokeWidth={1.5} /> @pasionaria30
          </a>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp"
            className="flex items-center gap-2 text-canvas/70 hover:text-canvas text-sm transition-colors"
          >
            <MessageCircle size={18} strokeWidth={1.5} /> WhatsApp
          </a>
        </div>
      </div>
      <div className="border-t border-canvas/10 py-6 text-center text-canvas/40 text-xs">
        © {new Date().getFullYear()} Pasionaria. {t("footer_rights")}
      </div>
    </footer>
  );
};
